import { render, staticRenderFns } from "./AddEditRoles.vue?vue&type=template&id=d95db5b8&"
import script from "./AddEditRoles.vue?vue&type=script&lang=js&"
export * from "./AddEditRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports